import React from 'react';
interface MortgageDepotLogoProps {
  className?: string;
}
/**
 * Mortgage Depot brand mark — official logo asset.
 */
export function MortgageDepotLogo({
  className
}: MortgageDepotLogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/19wQMHfHS7exi5BWJhECvC/mtgdepot_logo.png" alt="Mortgage Depot" className={`${className ?? ''} object-contain`} data-id="element-441" />;
}